import { CursorPagingData, PagingData } from 'interfaces/common';
import { Notification } from 'interfaces/notification';
import {
  AcceptPushNotificationPayload,
  FindAllNotificationPayload,
  FindAllNotificationsV2,
  UpdateNotificationPayload,
} from 'types/notification';
import axiosClient from 'utils/axios-client';

export const notificationsAPI = {
  findAll: async (
    payload: FindAllNotificationPayload,
  ): Promise<PagingData<Notification>> => {
    return await axiosClient.get('notifications', { params: payload });
  },
  update: async (payload: UpdateNotificationPayload): Promise<Notification> => {
    return await axiosClient.put(`notifications/read/${payload.id}`);
  },
  count: async (): Promise<PagingData<Notification>> => {
    return await axiosClient.get('notifications/count');
  },
  acceptPushNotification: async (payload: AcceptPushNotificationPayload) => {
    return await axiosClient.post(
      'notifications/accept-push-notification',
      payload,
    );
  },
  findAllV2: (
    payload: FindAllNotificationsV2,
  ): Promise<CursorPagingData<Notification>> => {
    return axiosClient.get('v2/notifications', { params: payload });
  },
  readAll: (): Promise<void> => {
    return axiosClient.put('notifications/read-all');
  },
};
